/*
 * @Author: lihy lihy@zhiannet.com
 * @Date: 2024-07-15 19:22:42
 * @LastEditors: lihy lihy@zhiannet.com
 * @LastEditTime: 2025-06-23 18:59:39
 * @FilePath: /nstk/src/src/config/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios"
import { getSystemConfig } from "@/api/teacher"
import type { App } from "vue"

let config: object = {}
const { VITE_PUBLIC_PATH } = import.meta.env

const setConfig = (cfg?: unknown) => {
  config = Object.assign(config, cfg)
}

const getConfig = (key?: string): PlatformConfigs => {
  if (typeof key === "string") {
    const arr = key.split(".")
    if (arr && arr.length) {
      let data = config
      arr.forEach((v) => {
        if (data && typeof data[v] !== "undefined") {
          data = data[v]
        } else {
          data = null
        }
      })
      return data
    }
  }
  return config
}

/** 获取项目动态全局配置 */
export const getPlatformConfig = async (app: App): Promise<undefined> => {
  app.config.globalProperties.$config = getConfig()

  // 动态确定配置文件的URL
  let configUrl = `${VITE_PUBLIC_PATH}platform-config.json`

  // 如果VITE_PUBLIC_PATH为空或为"/"，根据当前路径确定
  if (!VITE_PUBLIC_PATH || VITE_PUBLIC_PATH === "/") {
    const hostname = window.location.hostname
    const port = window.location.port
    const currentPath = window.location.pathname
    
    // 开发环境（localhost:9527）
    if (hostname === 'localhost' && port === '9527') {
      configUrl = "/platform-config.json"
    }
    // 生产环境：检查路径中是否包含 /web/
    else if (currentPath.includes('/web/')) {
      configUrl = "/web/platform-config.json"
    } else {
      configUrl = "/platform-config.json"
    }
  }

  return axios({
    method: "get",
    url: configUrl
  })
    .then(async ({ data: config }) => {
      let $config = app.config.globalProperties.$config
      // 自动注入系统配置
      if (app && $config && typeof config === "object") {
        $config = Object.assign($config, config)
        try {
          // 优先使用后台系统配置覆盖Title
          const proj = await getSystemConfig("ProjName")
          const runtimeTitle = (proj?.value || "").trim()
          if (runtimeTitle) {
            ;($config as any).Title = runtimeTitle
          }
          // 同步浏览器标签（无具体路由meta时）
          if ((document as any)) {
            document.title = (runtimeTitle || ($config as any).Title || document.title) as string
          }
        } catch {
          // ignore
        }
        app.config.globalProperties.$config = $config
        // 设置全局配置
        setConfig($config)
      }
      return $config
    })
    .catch(() => {
      throw "请在public文件夹下添加platform-config.json配置文件"
    })
}

/** 本地响应式存储的命名空间 */
const responsiveStorageNameSpace = () => getConfig().ResponsiveStorageNameSpace

export { getConfig, setConfig, responsiveStorageNameSpace }
